import React, {  Component } from 'react';

export default class SelectProductsToReturnOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('SelectProductsToReturnOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectProductsToReturnOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Select Products to Return</h2>
					<p>Select the product(s) and/or service(s) you need to return and the quantity you want to return.</p>
					<form className="selectProductsToReturnForm" name="selectProductsToReturnForm" id="selectProductsToReturnForm" action="PUT_FORM_ACTION_URL_HERE">
				        <table className="dataTable selectProductsToReturnTable">
							<caption>
								<big className="bold">CSO (Order number): 999999999 &nbsp; &nbsp; Order Date: 99/99/9999 &nbsp; &nbsp; P.O. # ABC123DEF456</big>
							</caption>
			          		<thead>
								<tr>
									<th className="select">Select</th>
									<th className="product">Product</th>
									<th className="description">Description</th>
									<th className="price">Price <span className="unbold">(Each)</span></th>
									<th className="invoiceNumber">Invoice #</th>
									<th className="quantityOrdered">Quantity Ordered</th>
									<th className="quantityToReturn">Quantity to Return</th>
								</tr>
				          	</thead>
				          	<tbody>
								<tr>
									<td className="select">
										<input type="checkbox" name="selectProductToReturn" className="selectProductToReturnCheckbox" id="selectProductToReturn_SKU1" defaultValue="SKU1" />
									</td>
									<td className="product">
										<label htmlFor="selectProductToReturn_SKU1"> SKU1SKU1SKU1</label>
									</td>
									<td className="description">Product Description</td>
									<td className="price">$9999.99</td>
									<td className="invoiceNumber">1234567890</td>
									<td className="quantityOrdered">99</td>
									<td className="quantityToReturn">
										<select className="quantityToReturnDropdown" name="quantityToReturn_SKU1" disabled>
											<option>1</option>
											<option>2</option>
											<option>3</option>
										</select>
									</td>
								</tr>
							</tbody>
						</table>
						<div className="noButtonContainer">
							<a className="noButton blueButton" href="" onClick={this.closeDialog.bind(this)}>Cancel</a>
						</div>
						<div className="yesButtonContainer">
							<input type="submit" className="yesButton blueButton" value="Add to Return" />
						</div>
			      	</form>
             	</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectProductsToReturnOverlayDialog.js